/**
 * The promo deadline is stored in the free-text `contact.eori` field, so the
 * value arrives however it was typed in the admin — e.g. "2026-10-01 T:23:59:00",
 * which `new Date()` rejects outright. Pull the parts out instead of trusting
 * the separators, and treat the result as local time.
 */
const ISO_LIKE = /(\d{4})-(\d{1,2})-(\d{1,2})(?:\D+(\d{1,2})[:.](\d{2})(?:[:.](\d{2}))?)?/;
const DOTTED = /(\d{1,2})\.\s*(\d{1,2})\.\s*(\d{4})(?:\D+(\d{1,2})[:.](\d{2})(?:[:.](\d{2}))?)?/;

export function parseDeadline(value: string | null | undefined): Date | null {
  if (!value || typeof value !== 'string') return null;

  const isoMatch = value.match(ISO_LIKE);
  const dottedMatch = isoMatch ? null : value.match(DOTTED);

  const [year, month, day] = isoMatch
    ? [isoMatch[1], isoMatch[2], isoMatch[3]]
    : dottedMatch
      ? [dottedMatch[3], dottedMatch[2], dottedMatch[1]]
      : [];

  if (!year) return null;

  const time = isoMatch ?? dottedMatch;
  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(time?.[4] ?? 0),
    Number(time?.[5] ?? 0),
    Number(time?.[6] ?? 0),
  );

  return isNaN(date.getTime()) ? null : date;
}

export function isDeadlineActive(value: string | null | undefined) {
  const deadline = parseDeadline(value);

  return deadline !== null && deadline.getTime() > Date.now();
}
